const c = {
  name: "LpmLatam",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,19.7C39.8,9,31,0.2,20.4,0c-0.1,0-0.2,0-0.4,0C14.5,0,9.2,2.3,5.5,6.3C5,6.1,4.5,6,4,6c-2.2,0-4,1.8-4,4
			c0,1.1,0.5,2.2,1.3,2.9C0.5,15.2,0,17.6,0,20s0.4,4.8,1.3,7.1C0.5,27.8,0,28.9,0,30c0,2.2,1.8,4,4,4c0.5,0,1-0.1,1.5-0.3
			C5.7,34,6,34.3,6.3,34.5C6.1,35,6,35.5,6,36c0,2.2,1.8,4,4,4c1.1,0,2.2-0.5,2.9-1.3c2.2,0.8,4.6,1.3,7.1,1.3
			c3.2,0,6.4-0.8,9.3-2.3C35.9,34.2,40,27.5,40,20C40,19.9,40,19.8,40,19.7z M37.9,18.9l-18.3,3.4c-0.4-0.9-1.1-1.5-1.9-1.9
			l3.4-18.3C30.1,2.6,37.4,9.9,37.9,18.9z M10.8,32.1C10.8,32.1,10.8,32.1,10.8,32.1c-0.2,0-0.4,0-0.6-0.1c-0.1,0-0.2,0-0.2,0
			c-0.7,0-1.4,0.2-2,0.6c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c0,0-0.1,0-0.1,0.1c-0.1-0.1-0.2-0.2-0.4-0.4c0,0,0,0,0.1-0.1
			c0.1-0.1,0.2-0.3,0.3-0.4c0,0,0.1-0.1,0.1-0.1c0.1-0.2,0.2-0.4,0.2-0.5c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.1,0-0.2
			c0-0.2,0-0.4,0-0.6c0-1.3-0.6-2.5-1.6-3.2L7.5,24c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.6,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4-0.1
			c0.7-0.2,1.4-0.6,1.9-1.2l1.1,0.5C12,23.5,12,23.7,12,24c0,1.2,0.5,2.3,1.4,3L10.8,32.1L10.8,32.1z M3.7,26c-0.2,0-0.4,0-0.7,0.1
			C2.4,24.2,2,22.1,2,20s0.4-4.2,1.1-6.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0
			c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0l1.1,2.8C4.6,17.5,4,18.7,4,20c0,1.3,0.6,2.5,1.6,3.2l-1.1,2.8C4.3,26,4,26,3.7,26L3.7,26z
			 M9.8,20.9c-0.4,0.9-1.5,1.4-2.5,0.9C6.5,21.6,6,20.8,6,20s0.5-1.5,1.3-1.8C7.5,18,7.8,18,8,18c1.1,0,2,0.9,2,2
			C10,20.3,9.9,20.6,9.8,20.9z M15.1,25.8c-0.7-0.3-1.1-1-1.1-1.8c0-0.3,0.1-0.6,0.2-0.9c0.3-0.7,1-1.1,1.8-1.1c0.1,0,0.3,0,0.4,0
			c0.8,0.1,1.5,0.8,1.6,1.6c0,0.1,0,0.2,0,0.4c0,0.5-0.2,1-0.6,1.4C16.8,26,15.9,26.2,15.1,25.8L15.1,25.8z M19.1,2l-3.3,18
			c-1.1,0.1-2.1,0.6-2.7,1.4l-1.1-0.5C12,20.6,12,20.3,12,20c0-2.2-1.8-4-4-4c-0.2,0-0.3,0-0.5,0.1l-1.1-2.8C7.4,12.5,8,11.3,8,10
			c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0,0,0-0.1,0-0.1C7.7,8.4,7.6,8.2,7.5,8.1c0,0-0.1-0.1-0.1-0.1
			C7.4,7.8,7.3,7.7,7.2,7.5c0,0,0-0.1-0.1-0.1C10.2,4.2,14.5,2.3,19.1,2L19.1,2z M4,8c0.4,0,0.8,0.1,1.1,0.3C5.7,8.7,6,9.3,6,10
			c0,0.8-0.5,1.6-1.3,1.8C4.5,12,4.1,12,3.8,12c-0.3,0-0.6-0.1-0.8-0.3c-0.6-0.4-1-1-1-1.7C2,8.9,2.9,8,4,8L4,8z M2,30
			c0-0.7,0.4-1.4,1-1.7c0.2-0.1,0.3-0.1,0.5-0.2c0,0,0.1,0,0.1,0C3.7,28,3.8,28,4,28c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0
			c0.1,0,0.3,0.1,0.4,0.1C5.5,28.4,6,29.2,6,30c0,0.7-0.3,1.3-0.9,1.7C4.8,31.9,4.4,32,4,32C2.9,32,2,31.1,2,30z M8,36
			c0-0.4,0.1-0.8,0.3-1.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1
			c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0
			c0.1,0,0.3,0.1,0.4,0.1c0.7,0.3,1.1,1,1.1,1.8c0,0.4-0.1,0.7-0.3,1c-0.4,0.6-1,1-1.7,1C8.9,38,8,37.1,8,36L8,36z M13.9,36.9
			c0-0.1,0-0.2,0.1-0.3c0,0,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-1.2-0.5-2.3-1.4-3l2.5-5.1C15.4,28,15.7,28,16,28c0.7,0,1.4-0.2,2-0.6
			l9.1,9.1C22.9,38.3,18.1,38.5,13.9,36.9L13.9,36.9z M29,35.6L19.4,26c0.3-0.5,0.5-1.1,0.5-1.7l18-3.3C37.7,27,34.3,32.5,29,35.6
			L29,35.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as LpmLatam
};
